import React, { useEffect, useState } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import { defiActifPourSemaine } from '../lib/helpers'
import { supabase } from '../lib/supabase'
import { JOURS, semaineCourante, decalerSemaine, formatSemaine } from '../lib/helpers'

const getKey = (semaine, jour, defiId) => `${semaine}-${jour}-${defiId}`
const JOURS_ECOLE = ['Lun','Mar','Mer','Jeu','Ven']

const NavSemaine = ({ semaine, onChange }) => (
  <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
    <button onClick={() => onChange(decalerSemaine(semaine, -1))} style={{ background: 'rgba(255,255,255,0.2)', border: 'none', borderRadius: 6, color: '#fff', padding: '4px 10px', cursor: 'pointer', fontSize: 16 }}>‹</button>
    <span style={{ color: '#fff', fontSize: 13, fontWeight: 600, minWidth: 120, textAlign: 'center' }}>{formatSemaine(semaine)}</span>
    <button onClick={() => onChange(decalerSemaine(semaine, 1))} style={{ background: 'rgba(255,255,255,0.2)', border: 'none', borderRadius: 6, color: '#fff', padding: '4px 10px', cursor: 'pointer', fontSize: 16 }}>›</button>
  </div>
)

const SectionTableau = ({ titre, couleur, defis, saisies, semaine, statsDefis, jours }) => (
  <div style={{ background: '#fff', borderRadius: 12, border: '1px solid #e2e8f0', overflow: 'hidden', marginBottom: 16 }}>
    <div style={{ padding: '10px 16px', background: couleur, borderBottom: '1px solid #e2e8f0' }}>
      <span style={{ fontSize: 13, fontWeight: 700, color: '#1e293b', fontFamily: "'Playfair Display', serif" }}>{titre}</span>
    </div>
    <div style={{ overflowX: 'auto' }}>
      <table style={{ width: '100%', borderCollapse: 'collapse', minWidth: 480 }}>
        <thead>
          <tr style={{ background: '#f8fafc' }}>
            <th style={{ padding: '10px 14px', textAlign: 'left', fontSize: 12, color: '#94a3b8', fontWeight: 600 }}>Défi</th>
            <th style={{ padding: '10px 6px', textAlign: 'center', fontSize: 11, color: '#94a3b8' }}>Pts</th>
            {jours.map(j => <th key={j} style={{ padding: '10px 4px', textAlign: 'center', fontSize: 11, color: '#94a3b8', fontWeight: 600 }}>{j.slice(0,3)}</th>)}
            <th style={{ padding: '10px 10px', textAlign: 'center', fontSize: 11, color: '#94a3b8' }}>%</th>
          </tr>
        </thead>
        <tbody>
          {defis.map((d, i) => {
            const stat = statsDefis.find(s => s.id === d.id)
            return (
              <tr key={d.id} style={{ borderTop: '1px solid #f1f5f9', background: i % 2 === 0 ? '#fff' : '#fafafa' }}>
                <td style={{ padding: '10px 14px', fontSize: 13, fontWeight: 600, color: '#1e293b', whiteSpace: 'nowrap' }}>
                  <span style={{ marginRight: 6 }}>{d.emoji}</span>{d.label}
                </td>
                <td style={{ padding: '6px', textAlign: 'center', fontSize: 12, color: '#64748b' }}>{d.points}</td>
                {jours.map(j => {
                  const v = saisies[getKey(semaine, j, d.id)] ?? 0
                  return (
                    <td key={j} style={{ padding: '6px 4px', textAlign: 'center' }}>
                      <div style={{ width: 28, height: 28, borderRadius: '50%', background: v > 0 ? '#2563eb' : '#f1f5f9', color: v > 0 ? '#fff' : '#cbd5e1', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: 'auto', fontSize: 11, fontWeight: 700 }}>
                        {v > 0 ? v : '–'}
                      </div>
                    </td>
                  )
                })}
                <td style={{ padding: '6px 10px', textAlign: 'center' }}>
                  <span style={{ fontSize: 12, fontWeight: 700, color: (stat?.pct ?? 0) >= 80 ? '#16a34a' : (stat?.pct ?? 0) >= 50 ? '#d97706' : '#dc2626' }}>
                    {stat?.pct ?? 0}%
                  </span>
                </td>
              </tr>
            )
          })}
        </tbody>
      </table>
    </div>
  </div>
)

const SectionTendances = ({ titre, couleur, statsDefis }) => (
  <div style={{ marginBottom: 16 }}>
    <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 10 }}>
      <div style={{ width: 3, height: 18, background: couleur, borderRadius: 2 }} />
      <span style={{ fontSize: 14, fontWeight: 700, color: '#1e293b', fontFamily: "'Playfair Display', serif" }}>{titre}</span>
    </div>
    {statsDefis.map(d => (
      <div key={d.id} style={{ marginBottom: 10 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 4 }}>
          <span style={{ fontSize: 13, color: '#374151' }}>{d.emoji} {d.label}</span>
          <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
            <span style={{ fontSize: 11, color: '#94a3b8' }}>{d.reussis}/{d.joursRemplis} j.</span>
            <span style={{ fontSize: 12, fontWeight: 700, color: d.pct >= 80 ? '#16a34a' : d.pct >= 50 ? '#d97706' : '#dc2626' }}>{d.pct}%</span>
          </div>
        </div>
        <div style={{ height: 6, background: '#f1f5f9', borderRadius: 3 }}>
          <div style={{ height: '100%', width: `${d.pct}%`, background: d.pct >= 80 ? '#22c55e' : d.pct >= 50 ? '#f59e0b' : '#ef4444', borderRadius: 3, transition: 'width 0.8s' }} />
        </div>
      </div>
    ))}
  </div>
)

export default function PageTherapeutique() {
  const { id } = useParams()
  const navigate = useNavigate()
  const [pseudonyme, setPseudonyme] = useState('')
  const [autorise, setAutorise] = useState(false)
  const [defis, setDefis] = useState([])
  const [saisies, setSaisies] = useState({})
  const [semaine, setSemaine] = useState(semaineCourante())
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const enfantId = sessionStorage.getItem('therapeute_enfant_id')
    const pseudo = sessionStorage.getItem('therapeute_pseudonyme')
    if (enfantId !== id) { navigate('/acces-therapeute'); return }
    setPseudonyme(pseudo || '')
    setAutorise(true)
  }, [id])

  useEffect(() => {
    if (!autorise) return
    const charger = async () => {
      setLoading(true)
      // RPC SECURITY DEFINER : un seul appel, données filtrées côté serveur
      const code = sessionStorage.getItem('therapeute_code')
      const { data, error } = await supabase.rpc('therapeute_get_all_data', {
        p_code: code, p_enfant_id: id
      })
      if (error) { console.error('RPC therapeute_get_all_data:', error); setLoading(false); return }
      setDefis(data?.defis || [])
      const map = {}
      ;(data?.saisies || [])
        .filter(s => s.semaine === semaine)
        .forEach(s => { map[getKey(s.semaine, s.jour, s.defi_id)] = s.valeur })
      setSaisies(map)
      setLoading(false)
    }
    charger()
  }, [autorise, id, semaine])

  if (!autorise) return null

  const defisMaison = defis.filter(d => d.type !== 'ecole' && defiActifPourSemaine(d, semaine))
  const defisEcole = defis.filter(d => d.type === 'ecole' && defiActifPourSemaine(d, semaine))

  const calcStats = (listeDefis, jours) => listeDefis.map(d => {
    let joursRemplis = 0, joursReussis = 0
    jours.forEach(j => {
      const aUneSaisie = listeDefis.some(dd => (saisies[getKey(semaine, j, dd.id)] ?? 0) > 0)
      if (aUneSaisie) {
        joursRemplis++
        if ((saisies[getKey(semaine, j, d.id)] ?? 0) > 0) joursReussis++
      }
    })
    const pct = joursRemplis > 0 ? Math.round((joursReussis / joursRemplis) * 100) : 0
    const pts = jours.reduce((s, j) => s + (saisies[getKey(semaine, j, d.id)] ?? 0), 0)
    return { ...d, pct, pts, reussis: joursReussis, joursRemplis }
  }).sort((a, b) => b.pct - a.pct)

  const statsMaison = calcStats(defisMaison, JOURS)
  const statsEcole = calcStats(defisEcole, JOURS_ECOLE)

  const totalSem = [...statsMaison, ...statsEcole].reduce((sum, d) => sum + d.pts, 0)

  return (
    <div style={{ minHeight: '100vh', background: '#f8fafc', fontFamily: "'Inter', sans-serif" }}>
      <header style={{ background: '#fff', borderBottom: '1px solid #e2e8f0', padding: '0 24px', height: 52 }}>
        <div style={{ maxWidth: 780, margin: '0 auto', height: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <button onClick={() => { sessionStorage.clear(); navigate('/acces-therapeute') }} style={{ display: 'flex', alignItems: 'center', gap: 6, padding: '5px 10px', borderRadius: 6, border: '1px solid #e2e8f0', background: '#fff', color: '#64748b', fontSize: 12, fontWeight: 600, cursor: 'pointer', fontFamily: "'Inter', sans-serif" }}>
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M19 12H5M12 19l-7-7 7-7"/></svg>
              Déconnexion
            </button>
            <div style={{ width: 1, height: 20, background: '#e2e8f0' }} />
            <span style={{ fontFamily: "'Playfair Display', serif", fontWeight: 700, fontSize: 16, color: '#1e293b' }}>{pseudonyme}</span>
          </div>
          <span style={{ fontSize: 11, color: '#0369a1', background: '#f0f9ff', padding: '3px 10px', borderRadius: 20, border: '1px solid #bae6fd' }}>Lecture seule — Équipe thérapeutique</span>
        </div>
      </header>

      <div style={{ maxWidth: 780, margin: '0 auto', padding: 16 }}>
        <div style={{ background: '#f0f9ff', border: '1px solid #bae6fd', borderRadius: 10, padding: '10px 16px', marginBottom: 16, display: 'flex', alignItems: 'center', gap: 8 }}>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#0369a1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><path d="M12 8v4M12 16h.01"/></svg>
          <span style={{ fontSize: 12, color: '#0369a1', fontWeight: 500 }}>Accès en lecture seule. Vous visualisez les données sans pouvoir les modifier.</span>
        </div>

        <div style={{ background: 'linear-gradient(135deg, #1e3a5f, #2563eb)', borderRadius: 14, padding: '16px 20px', marginBottom: 16 }}>
          <div style={{ color: '#fff', fontWeight: 700, fontSize: 15, marginBottom: 10, fontFamily: "'Playfair Display', serif" }}>
            Suivi de {pseudonyme}
          </div>
          <NavSemaine semaine={semaine} onChange={setSemaine} />
          <div style={{ marginTop: 10, color: 'rgba(255,255,255,0.8)', fontSize: 13 }}>
            Total semaine : <strong>{totalSem} points</strong>
          </div>
        </div>

        {loading ? (
          <div style={{ textAlign: 'center', padding: 32, color: '#64748b' }}>Chargement...</div>
        ) : (
          <>
            {defisMaison.length > 0 && (
              <SectionTableau titre="Défis à la maison" couleur="#EFF6FF" defis={defisMaison} saisies={saisies} semaine={semaine} statsDefis={statsMaison} jours={JOURS} />
            )}
            {defisEcole.length > 0 && (
              <SectionTableau titre="Défis à l'école" couleur="#FEF9C3" defis={defisEcole} saisies={saisies} semaine={semaine} statsDefis={statsEcole} jours={JOURS_ECOLE} />
            )}

            <div style={{ background: '#fff', borderRadius: 12, border: '1px solid #e2e8f0', padding: '16px 20px' }}>
              <div style={{ fontFamily: "'Playfair Display', serif", fontSize: 15, fontWeight: 700, color: '#1e293b', marginBottom: 14 }}>Tendances</div>
              {statsMaison.length > 0 && (
                <SectionTendances titre="Défis à la maison" couleur="#2563eb" statsDefis={statsMaison} />
              )}
              {statsEcole.length > 0 && (
                <SectionTendances titre="Défis à l'école" couleur="#d97706" statsDefis={statsEcole} />
              )}
            </div>
          </>
        )}

        <div style={{ textAlign: 'center', marginTop: 24, fontSize: 11, color: '#94a3b8' }}>
          Offert par <a href="https://nutrygenius.com" target="_blank" rel="noreferrer" style={{ color: '#2563eb' }}>NutryGenius®</a>
        </div>
      </div>
    </div>
  )
}
